import { FC } from 'react';
import { useParams } from 'react-router-dom';
import PageTemplate from 'components/pageTemplate';
import SavedEntities from 'components/savedEntities';
import savedEntities from 'constants/savedEntities';
import BatchDetail from 'pages/payouts/components/batch';
import queryString from 'query-string';
import tableNames from 'constants/tableNames';
import { ManualPaymentsList } from './ManualPaymentsList';
import { ManualPaymentsForm, manualPaymentsTabs } from './ManualPaymentsForm';
import PaymentCard from 'components/paymentCard';

const ManualPayments: FC = () => {
  const params = useParams<{ id: string }>();
  const { type } = queryString.parse(location.search);

  const renderContent = () => {
    const isCreating = manualPaymentsTabs
      .map(({ path }) => path)
      .includes(params.id);

    if (isCreating) {
      return (
        <PageTemplate.Container>
          <ManualPaymentsForm />
        </PageTemplate.Container>
      );
    }

    if (params.id) {
      return type === 'batch' ? (
        <BatchDetail id={params.id} tableName={tableNames.manualPayments} />
      ) : (
        <PaymentCard
          savedEntity={savedEntities.manualPayments}
          id={params.id}
        />
      );
    }

    return (
      <PageTemplate.Container>
        <ManualPaymentsList />
      </PageTemplate.Container>
    );
  };

  return (
    <PageTemplate.Main>
      <PageTemplate.Entities>
        <SavedEntities entityKey={savedEntities.manualPayments} />
      </PageTemplate.Entities>
      {renderContent()}
    </PageTemplate.Main>
  );
};

export default ManualPayments;
